/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ pool: NonNullable<unknown>, extra: NonNullable<unknown>, remaining: NonNullable<unknown> }} Usage_Status_Subline_NormalInputs */



/**
* | output |
* | --- |
* | "{pool} from your pool + {extra} extra. {remaining} of extra usage remaining." |
*
* @param {Usage_Status_Subline_NormalInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const usage_status_subline_normal = /** @type {((inputs: Usage_Status_Subline_NormalInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Status_Subline_NormalInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.pool} aus Ihrem Pool + ${i?.extra} extra. ${i?.remaining} Extra-Verbrauch verbleibend.`)
	return /** @type {LocalizedString} */ (`${i?.pool} from your pool + ${i?.extra} extra. ${i?.remaining} of extra usage remaining.`)
});